import AutocompleteCheckboxButtons, { AutocompleteCheckbox } from './autocomplete.checkbox.jsx';
import React from 'react';
import _ from '../../i18n.jsx';
import style from '../number.input/number.input.less';
import checkboxStyle from './checkbox.less';
import classNames from 'classnames';
import { Checkbox } from './checkbox.jsx';
import autocompleteCheckboxWithAge from './autocomplete.checkbox.with.diagnosis.age.less';
import NumberInput from '../number.input/number.input.jsx';

const UNKNOWN = 'UNKNOWN';

class CheckboxWrapper extends Checkbox {
    constructor() {
        super();
        this.onCheckHandler = this.onCheckHandler.bind(this);
    }
    onCheckHandler(event) {
        this.props.onChangeCallback(this.props.inputIndex, event);
    }
    render() {
        const { inputIndex, name, checked } = this.props;
        return (
            <Checkbox {...this.props} value={inputIndex} num={inputIndex} id={name} checked={checked}
                name={name} title={name} onChangeCallback={this.onCheckHandler}
            />
        );
    }
}

class NumberInputWrapper extends NumberInput {
    constructor() {
        super();
        this.onChangeAgeHandler = this.onChangeAgeHandler.bind(this);
    }
    onChangeAgeHandler(event) {
        this.props.onChangeAgeCallback(this.props.inputIndex, event);
    }
    render() {
        const { AGE_OF_DIAGNOSIS, YEARS } = NumberInputWrapper.STRINGS;
        const visible = this.props.visible;
        return visible ? <NumberInput {...this.props} length="3" caption={AGE_OF_DIAGNOSIS} onChangeCallback={this.onChangeAgeHandler} label={YEARS} /> : null;
    }
}

NumberInputWrapper.STRINGS = {
    AGE_OF_DIAGNOSIS: _('Age of diagnosis'),
    YEARS: _('YEARS')
};

export default class AutocompleteCheckboxButtonsWithAge extends AutocompleteCheckboxButtons {
    constructor() {
        super();
        this.buildInputList = this.buildInputList.bind(this);
        this.onChangeAgeHandler = this.onChangeAgeHandler.bind(this);
    }
    onChangeAgeHandler(inputIndex, eventOrValue) {
        const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;
        const { name, root } = this.props;
        const { arrayOfItems } = this.state;
        const currentItem = arrayOfItems[inputIndex - 1];
        currentItem.age = value;

        const itemsId = arrayOfItems.reduce((itemsList, item) => {
            if (item.checked) { itemsList.push(item.age ? `${item.id},${item.age}` : item.id); }
            return itemsList;
        }, [/* _NEW_ empty array */]);

        this.setState({ arrayOfItems, currentInputIndex: parseInt(inputIndex) });
        this._setFieldValue(name, itemsId, root);
    }
    buildInputList() {
        const { arrayOfItems, currentInputIndex } = this.state;
        const { showAll, disabled } = this.props;
        const inputs = [];
        for (let inputIndex = 1; inputIndex <= arrayOfItems.length + 1; inputIndex++) {
            const currentElement = arrayOfItems[inputIndex - 1];
            const readonly = currentElement ? currentElement.readonly : false;
            const diagnosisAgeInput = currentElement ? currentElement.checked : false;
            const diagnosisAgeValue = currentElement ? currentElement.age : null;
            const diagnosisWrapperClass = classNames(autocompleteCheckboxWithAge.ageWrapper, style.fieldWrapper, { [style.hidden]: !diagnosisAgeInput });
            const diagnosisInputClass = classNames(style.textInput, autocompleteCheckboxWithAge.diagnosisAgeInput);
            if (!readonly) {
                inputs.push(
                    <AutocompleteCheckbox {...this.props} onChangeCallback={this.onChangeHandler}
                        key={`autocompleteCheckbox-${inputIndex}`} inputIndex={inputIndex} onFocusCallback={this.onFocusHandler}
                        onOptionClickCallback={this.optionClickHandler} onCheckCallback={this.onCheckHandler}
                        wrapperClass={autocompleteCheckboxWithAge.ageInput} currentElement={currentElement}
                        currentInputIndex={currentInputIndex} cssClass={autocompleteCheckboxWithAge.autocompleteInput} showAll={showAll}
                    />,
                    <NumberInputWrapper
                        captionClass={autocompleteCheckboxWithAge.diagnosisAgeLabel} disabled={disabled} inputIndex={inputIndex}
                        wrapperClass={diagnosisWrapperClass} cssClass={diagnosisInputClass} onChangeAgeCallback={this.onChangeAgeHandler}
                        key={`numberInput-${inputIndex}`} value={diagnosisAgeValue} visible={diagnosisAgeInput}
                    />,
                    <div key={`autocomplete-${inputIndex}`} className={autocompleteCheckboxWithAge.clearBoth}></div>
                );
            } else {
                inputs.push(
                    <CheckboxWrapper {...this.props} value={currentElement.name} inputIndex={inputIndex} name={currentElement.name}
                        id={`checkbox-${inputIndex}`} checked={currentElement.checked} num={inputIndex} key={`checkbox-${inputIndex}`}
                        onChangeCallback={this.onCheckHandler} title={currentElement.name} cssClass={autocompleteCheckboxWithAge.ageInput}
                    />,
                    <NumberInputWrapper
                        captionClass={autocompleteCheckboxWithAge.diagnosisAgeLabel} disabled={disabled} inputIndex={inputIndex}
                        wrapperClass={diagnosisWrapperClass} cssClass={diagnosisInputClass} onChangeAgeCallback={this.onChangeAgeHandler}
                        key={`numberInput-${inputIndex}`} value={diagnosisAgeValue} visible={diagnosisAgeInput}
                    />,
                    <div key={`defaultVariant-${inputIndex}`} className={autocompleteCheckboxWithAge.clearBoth}></div>
                );
            }
        }
        return inputs;
    }
    render() {
        const { value, unknownAccepted } = this.props;
        const wrapperClass = classNames(autocompleteCheckboxWithAge.wrapper, checkboxStyle.fieldWrapper);
        return (
            <div className={wrapperClass}>
                { this.buildInputList() }
                {
                    unknownAccepted
                        ? <DontKnowBtn value={UNKNOWN} onChangeCallback={this.onChangeHandler} checked={ UNKNOWN === value }/>
                        : null
                    }
            </div>
        );
    }
}
